/**
 * @fileoverview Main entry point for the My Yenta application.
 * This file is responsible for loading the appropriate application based on the URL path.
 * It also handles the loading of the application and the error handling.
 */

import { createRoot } from "react-dom/client";
import React, { Suspense, lazy } from "react";
// import { Loader, MantineProvider } from '@mantine/core';

const root = document.getElementById("root")!;
const inTestMode = window.location.pathname.startsWith('/t/') || window.location.pathname.startsWith('/tr/');
const inYentaMode = window.location.pathname.startsWith('/yenta/portal');
const inAccessoractivationMode = window.location.pathname.startsWith('/magic');

const TestAppComponent = lazy(() => import('./testee/main.tsx'));
const AdminAppComponent = lazy(() => import('./app/main.tsx'));
const TheyentaportalAppComponent = lazy(() => import('./theyentaportal/main.tsx'));
const AccessoractivationAppComponent = lazy(() => import('./accessoractivation/main.tsx'));

const AppLoader = () => {
    if (inTestMode) {
        return <TestAppComponent />;
    }
    if (inYentaMode) {
        return <TheyentaportalAppComponent />;
    }
    if (inAccessoractivationMode) {
        return <AccessoractivationAppComponent />;
    }
    return <AdminAppComponent />;
};

const loadApp = async () => {
    try {
        createRoot(root).render(
            <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }}><span>Loading...</span></div>}>
                <AppLoader />
            </Suspense>
        );
    } catch (error) {
        console.error(error);
    }
}

loadApp();